"use client";

import { handleGenerateProductLinkProps } from "@faire/deprecated-retailer-visitor-shared/components/SearchProducts/utils";
import { ProductUrlParameters } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/useProductLinkProps";
import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageFilterKeys } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/useSearchPageFilterKeys";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useGenerateProductLinkPropsFn = (params: ProductUrlParameters) => {
  const productSearchString = useSearchPageProductSearchString();
  const filterKeys = useSearchPageFilterKeys();
  const location = useLocation();
  const user = getUser();
  const getLinkPropsFn = handleGenerateProductLinkProps(
    productSearchString,
    params,
    // TODO: it looks like this field isn't used, we only pass refF to the backend on the brand page
    filterKeys || [],
    location,
    user
  );
  const linkProps = useMemo(() => getLinkPropsFn(), [getLinkPropsFn]);
  return linkProps;
};
